import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-aurea-slider-logo",
  templateUrl: "./aurea-slider-logo.component.html",
  styleUrls: ["./aurea-slider-logo.component.scss"],
})
export class AureaSliderLogoComponent implements OnInit {
  logos = [{ svg: "assets/img/aurea/aurea_logo_orange.svg" }];

  slideConfig = {
    dots: false,
    arrows: false,
  };
  constructor() {}

  ngOnInit() {}
}
